import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  const quotes = ['Soy el único que sabe cómo se hacen las cosas acá', 'Si me voy una semana, todo se desordena', 'Mi equipo me consulta hasta para las decisiones más básicas', 'Trabajo más horas que cualquiera de mis empleados y aun así las cosas no salen bien'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-115">
      <div data-id="element-116">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-12" data-id="element-117">
          Si alguna vez pensaste alguna de estas cosas, seguí leyendo:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-118">
          {quotes.map((quote, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-slate-900/80 border border-slate-800 rounded-lg p-6 border-l-4 border-l-amber-500 shadow-lg" data-id="element-119">
              <p className="text-lg text-slate-300 italic" data-id="element-120">"{quote}"</p>
            </motion.div>)}
        </div>

        <div className="space-y-6 text-lg md:text-xl text-slate-300 leading-relaxed text-center max-w-3xl mx-auto" data-id="element-121">
          <p data-id="element-122">No estás solo. Y no es tu culpa.</p>
          <p data-id="element-123">
            Nadie te enseñó a construir una organización. Te enseñaron a
            trabajar duro, a ser el mejor en lo tuyo, a tener iniciativa.
          </p>
          <p data-id="element-124">
            Pero nadie te mostró{' '}
            <strong className="text-white font-bold" data-id="element-125">
              cómo hacer que tu empresa funcione sin que seas el centro de todo.
            </strong>
          </p>
          <p className="text-amber-500 font-bold text-2xl mt-8" data-id="element-126">
            Eso está a punto de cambiar.
          </p>
        </div>
      </div>
    </section>;
}